<template>
    <div>
        <!-- 弹窗容器 -->
        <popup-notification :key="containerKey"
            v-if="containerComponent === 'modal' || containerComponent === 'oldNewLabel'" :visible.sync="innerVisible"
            v-bind="passByValue" v-on="$listeners" @close="innerVisible = false" />

        <!-- 抽屉容器 -->
        <swipe-left v-if="containerComponent === 'drawer'" :key="containerKey" :visible.sync="innerVisible"
            v-bind="passByValue" v-on="$listeners" @close="innerVisible = false" />
    </div>
</template>

<script>
import popupNotification from './popupNotification.vue'
import swipeLeft from './swipeLeft.vue'
import { capabilityRegistry } from './introduceComponents.js'

export default {
    name: 'UiContainer',
    components: {
        popupNotification,
        swipeLeft
    },
    data() {
        return {
            containerMode: null, // 'modal' 或 'drawer'
            innerVisible: false,
            containerKey: 0,
            passByValue: {}
        }
    },
    watch: {
        innerVisible(val) {
            if ((this.$store.state.user.containerMode == 'tab' || this.$store.state.user.containerMode == 'originalPageSignature') && val) {
                let link = '?'
                if (this.passByValue)
                    for (let item in this.passByValue) {
                        if (typeof this.passByValue[item] !== 'function')
                            link += item + '=' + this.passByValue[item] + '&'
                    }
                if (this.$store.state.user.containerMode == 'tab')
                    window.open('/tabpage' + link, '_blank')
                else
                    this.$router.push('/tabpage' + link)
                this.innerVisible = false
            }
            if (!val) {
                this.containerKey++
            }
        },
    },
    computed: {
        containerComponent() {
            return this.$store.state.user.containerMode
        }
    },
    methods: {
        async open(data) {
            this.passByValue = data
            const loader = capabilityRegistry[data.capabilityKey]
            if (!loader) {
                console.error('未注册组件:', data.capabilityKey)
                return
            }
            const mod = await loader()
            this.currentComp = mod.default || mod
            this.innerVisible = true
        },
    },
}
</script>
